import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  quote: string;
  imageInitials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote,
  imageInitials
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-240">
      <div className="flex items-center gap-1 mb-4 text-yellow-400" data-id="element-241">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} fill="currentColor" className="w-5 h-5" data-id="element-242" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-243">"{quote}"</p>
      <div className="flex items-center gap-4 mt-auto" data-id="element-244">
        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center text-purple-700 font-bold text-lg shrink-0" data-id="element-245">
          {imageInitials}
        </div>
        <div data-id="element-246">
          <h4 className="font-bold text-gray-900" data-id="element-247">{name}</h4>
          <p className="text-sm text-gray-500" data-id="element-248">
            {role} • {location}
          </p>
        </div>
      </div>
    </div>;
}